// @core/api/endpoints/chat/resolve_chat_context.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ResolveChatContextRequest,
  ResolveChatContextResponse,
} from '../../../types/chat';

const BASE_PATH = '/chat';

/**
 * Resolve chat context
 * Resolves the effective chat policy for a scope entity by merging the policy hierarchy.
 */
export async function ResolveChatContext(
  data: ResolveChatContextRequest,
  options?: RequestOptions
): Promise<ResolveChatContextResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/chat/resolve-context`;
  const requestOptions = options;
  return client.post<ResolveChatContextResponse>(requestPath, data, requestOptions);
}
